import { DISMISS_MESSAGE, SHOW_MESSAGE } from './constants';
import { showNotification } from '../../common/helpers/notifications';
import { popMessage } from './actions';

const middleware = store => next => (action) => {
  if (action.type === SHOW_MESSAGE && action.payload.duration) {
    showNotification({
      title: action.payload.title,
      level: action.payload.level,
      message: action.payload.message,
      autoDismiss: action.payload.duration,
      position: 'tr',
    });
    return;
  }

  if (action.type === DISMISS_MESSAGE) {
    next(action);
    setImmediate(() => store.dispatch(popMessage()));
    return;
  }

  next(action);
};

export default middleware;
